import { DASHBOARDS_BASE_URL } from "../constants/urls";
import { ProductionArea } from "../enums";

const ROOT_EQUIPMENT_ALL = "all";

export type BuildConditionMonitoringUrlArgs = {
  site: string;
  rootEquipment?: string;
  productionArea?: string;
  systemOverviewReport?: string;
  projectOverviewReport?: string;
};

export function resolveReportName(
  productionArea: string | undefined,
  systemOverviewReport: string | undefined,
  projectOverviewReport: string | undefined
): string {
  switch (productionArea) {
    case ProductionArea.Grinding:
      return systemOverviewReport ?? "";
    case ProductionArea.HPR:
    case ProductionArea.Hoisting:
      return projectOverviewReport ?? "";
    default:
      return systemOverviewReport ?? projectOverviewReport ?? "";
  }
}

export function resolveRootEquipment(
  rootEquipment: string | undefined,
  productionArea: string | undefined
): string | undefined {
  switch (productionArea) {
    case ProductionArea.Grinding:
      return rootEquipment;
    case ProductionArea.Hoisting:
      return ROOT_EQUIPMENT_ALL;
    case ProductionArea.HPR:
      return undefined;
    default:
      return rootEquipment;
  }
}

function resolveRootPath(
  rootEquipment: string | undefined,
  productionArea: string | undefined,
  site: string
): string {
  const resolvedRootEquipment = resolveRootEquipment(
    rootEquipment,
    productionArea
  );
  if (!resolvedRootEquipment) {
    return `${site}/${productionArea ?? ""}`;
  }
  return `${site}/${productionArea}/${resolvedRootEquipment ?? ""}`;
}

export function buildConditionMonitoringUrl({
  site,
  rootEquipment,
  productionArea,
  systemOverviewReport,
  projectOverviewReport,
}: BuildConditionMonitoringUrlArgs): string {
  const report = resolveReportName(
    productionArea,
    systemOverviewReport,
    projectOverviewReport
  );
  const rootPath = resolveRootPath(rootEquipment, productionArea, site);

  const dashboardRoute = `/report/${report}?rootPath=${encodeURIComponent(rootPath)}`;
  const params = new URLSearchParams({ dashboardRoute });

  return `${DASHBOARDS_BASE_URL}/dashboards/site/${site}?${params.toString()}`;
}
